const SUPPORTED_LOCALES = [
  'en',
  'en_uk',
  'fr',
  'it',
  'de',
  'es',
  'pt',
  'ja',
  'ko',
  'ru',
  'tr',
  'ar',
  'he',
  'nl',
  'zh-Hans',
  'zh-Hant',
];

const FALLBACK_LANGUAGE = 'en';

export const preferedLanguage = () => {
  const selectedLanguage = localStorage.getItem('i18nextLng');

  const normalizedLanguage = SUPPORTED_LOCALES.includes(selectedLanguage)
    ? selectedLanguage
    : selectedLanguage?.substring(0, 2);

  return SUPPORTED_LOCALES.includes(normalizedLanguage)
    ? normalizedLanguage
    : FALLBACK_LANGUAGE;
};
